import { DashboardOutlined } from '@ant-design/icons-vue'

export default [
  {
    path: '/screen/wulidun',
    name: 'wulidunScreen',
    component: () => import('@/views/screen/wulidun/index.vue'),
    meta: {
      title: '五里墩智慧大屏',
      icon: DashboardOutlined,
      isFullScreen: true,
      keepAlive: false,
      hidden: false,
      prem: true,
      sort: 98,
    },
  },
]
